import { inputDescLimit } from "../../../helpers/fieldRestriction";
import messages from "../../../locale/jsonMessages";

export const validate = (values) => {
    let errors = {}
    if (values?.dynamicCancellationInfo.length > 0) {
        let dynamicCancellationContent = [], cancellationInfoErrors = {}
        values.dynamicCancellationInfo.forEach((item, index) => {
            if (!item?.language || item?.language?.trim() == '') {
                cancellationInfoErrors.language = messages.required;
            }
            if (!item?.description || item?.description?.trim() == "") {
                cancellationInfoErrors.description = messages.required;
            } else if (item?.description?.length > inputDescLimit) {
                cancellationInfoErrors.description = messages.inputDescLimitError;
            }
            if (Object.keys(cancellationInfoErrors).length > 0) {
                dynamicCancellationContent[index] = cancellationInfoErrors
            }

        })
        if (dynamicCancellationContent?.length > 0)
            errors.dynamicCancellationInfo = dynamicCancellationContent
    }
    return errors

}